import React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { IIdName } from "api/entities/id-name";
import { ACCESS_CREDENTIALS_ROUTE } from "constants/routes";
import { bucketActions } from "redux/actions/bucket";
import { IAppState } from "redux/reducers";
import { useNavigate } from "react-router-dom";
import { ConfirmDialog } from "components/shared-ui/dialogs/common/confirm-dialog/confirm-dialog";
import styles from "../../../shard-clusters/dialogs/delete-blocked-confirmation/delete-blocked-confirmation.module.scss";

const mapDispatchToProps = (
    dispatch: ThunkDispatch<IAppState, void, Action>
) => {
    return {
        closeConfirmation: () => {
            dispatch(bucketActions.deleteBlockedConfirmation.close());
        }
    };
};

const mapStateToProps = (state: IAppState) => ({
    isOpen: state.bucket.deleteBlockedConfirmation.isOpen,
    data: state.bucket.deleteBlockedConfirmation.data,
})

export interface IDeleteBlockedConfirmationData {
    bucket: IIdName<string>;
    accessCredentials?: IIdName<string>[];
}

export interface IDeleteBlockedConfirmationProps extends
    ReturnType<typeof mapDispatchToProps>,
    ReturnType<typeof mapStateToProps> {
}


export const DeleteBlockedConfirmation = connect(mapStateToProps, mapDispatchToProps)((props: IDeleteBlockedConfirmationProps) => {
    const navigate = useNavigate();
    const accessCredentials = props.data?.accessCredentials;

    const isSingleDependency = accessCredentials?.length === 1;
    const dependencyName = isSingleDependency ? 'Access Credential' : 'Access Credentials';

    function handleConfirm() {
        props.closeConfirmation();
        if (accessCredentials?.length) {
            navigate(ACCESS_CREDENTIALS_ROUTE, { state: {bucket: String(props.data.bucket.id)} });
        }
    }

    function getUsedIn() {
        if (accessCredentials?.length > 1) {
            return `${accessCredentials?.length} different access credentials`;
        }
        if (accessCredentials?.length === 1) {
            return (<><strong>{accessCredentials[0].name}</strong> access credential</>);
        }
        return null;
    }

    return (
        <ConfirmDialog
            testId="delete-bucket-confirmation"
            title="Delete Bucket"
            confirmText={`View Linked ${dependencyName}`}
            open={props.isOpen}
            onClose={props.closeConfirmation}
            onConfirm={handleConfirm}
        >
            <div className={styles.content}>
                This Bucket is currently being used in {getUsedIn()}.
                If you still want to delete this Bucket, please delete {isSingleDependency ? 'the ' : ''}{dependencyName}.
            </div>
        </ConfirmDialog>
    )
});
